import React from 'react';
import PropTypes from 'prop-types';
import { CONTENT_TYPES } from '../../constants';
import Paragraph from '../../../../paragraph';
import SolidIcon from '../../../../solid-icon';

const RowItemCompact = ({ text = null, contentType = 'icon-check' }) => {
  const icon = () => {
    switch (contentType) {
      case CONTENT_TYPES['icon-not-available']:
        return <SolidIcon glyph="clear-search" type="error" size={14} strokeWidth={3} />;
      case CONTENT_TYPES['icon-check']:
      default:
        return <SolidIcon glyph="check" type="dark" size={14} strokeWidth={3} />;
    }
  };

  return (
    <div className="ws-ui-plan-row-item-compact">
      <span className="ws-ui-plan-row-item-compact__icon-wrapper">{icon()}</span>
      {text && <Paragraph>{text}</Paragraph>}
    </div>
  );
};

RowItemCompact.propTypes = {
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  contentType: PropTypes.oneOf(Object.values(CONTENT_TYPES)),
};

export default RowItemCompact;
